export default __webpack_public_path__ + "static/media/Inter-Bold.3717db0b.woff2";